import { createSelector } from '@ngrx/store';

import { JobItemsSelectors } from './jobs/jobs.store';
import { TalentPoolItemsSelectors } from './talent-pools/talent-pools.store';

const active = createSelector(
  JobItemsSelectors.active,
  TalentPoolItemsSelectors.active,
  (jobs, talentPools) => [...jobs, ...talentPools],
);
const all = createSelector(
  JobItemsSelectors.all,
  TalentPoolItemsSelectors.all,
  (jobs, talentPools) => [...jobs, ...talentPools],
);
const activeScopeIsLoaded = createSelector(
  JobItemsSelectors.activeScopeIsLoaded,
  TalentPoolItemsSelectors.activeScopeIsLoaded,
  (jobsLoaded, talentPoolsLoaded) => jobsLoaded && talentPoolsLoaded,
);
const canAssignTo = createSelector(
  JobItemsSelectors.canAssignTo,
  TalentPoolItemsSelectors.canAssignTo,
  (jobs, talentPools) => [...jobs, ...talentPools],
);

const selectors = {
  all,
  active,
  activeScopeIsLoaded,
  canAssignTo,
};

export { selectors as OfferItemsSelectors };
